import ChatSidebar from './ChatSidebar';
import ChatThread from './ChatThread';

function ChatSection({
    workspaceId,
    workspaces = [],
    onWorkspaceChange,
    sessions,
    sessionsLoading,
    activeSessionId,
    messages,
    inputValue,
    busy,
    progressStep,
    pendingConfirmation,
    onCreateSession,
    onSelectSession,
    onDeleteSession,
    onRenameSession,
    onClearMessages,
    onInputChange,
    onInputKeyDown,
    onSend,
    onMessageFeedback,
}) {
    const activeSession = sessions.find((s) => s.id === activeSessionId);

    return (
        <div className="panel chat-panel" data-testid="chat-section">
            <div className="chat-layout">
                <ChatSidebar
                    workspaceId={workspaceId}
                    workspaces={workspaces}
                    onWorkspaceChange={onWorkspaceChange}
                    sessions={sessions}
                    activeSessionId={activeSessionId}
                    onSelectSession={onSelectSession}
                    onCreateSession={onCreateSession}
                    onDeleteSession={onDeleteSession}
                    onRenameSession={onRenameSession}
                    loading={sessionsLoading}
                />
                <ChatThread
                    sessionId={activeSessionId}
                    sessionTitle={activeSession?.title}
                    busy={busy}
                    progressStep={progressStep}
                    messages={messages}
                    pendingConfirmation={pendingConfirmation}
                    inputValue={inputValue}
                    onInputChange={onInputChange}
                    onInputKeyDown={onInputKeyDown}
                    onSend={onSend}
                    onClearMessages={onClearMessages}
                    onMessageFeedback={onMessageFeedback}
                    workspaceSelected={Boolean(workspaceId)}
                />
            </div>
        </div>
    );
}

export default ChatSection;
